import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import cl from '../../pages/Cabinet/Modal.module.css';

/**
 * Модалка для пользователей, которые раньше входили через Google.
 *
 * Контекст: с 07.07.2026 вход через иностранные сервисы (Google) на российских
 * сайтах запрещён (поправки в 149-ФЗ), поэтому кнопка «Войти через Google»
 * убрана. У таких пользователей аккаунт НЕ теряется — в базе уже есть их email
 * и профиль. Нужно лишь выдать им пароль, чтобы они входили по e-mail.
 *
 * Механика восстановления (ручная, т.к. массовая email-рассылка отключена):
 * пользователь пишет письмо СО СВОЕЙ Google-почты (той самой, через которую
 * входил) на адрес поддержки. Отправка именно с этого ящика = доказательство
 * владения. Админ заводит пользователю пароль и присылает его ответным письмом.
 */

const SUPPORT_EMAIL = 'maksimivankov26@yandex.ru';

const EMAIL_BODY =
    'Здравствуйте! Я раньше входил(а) на сайт через Google с этой почты. ' +
    'Вход через Google закрыли — прошу создать мне пароль, чтобы я мог(ла) ' +
    'заходить по логину и паролю.';

export default function GoogleMigrationModal({ onClose }) {
    const [copied, setCopied] = useState('');

    const copy = async (text, what) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(what);
            setTimeout(() => setCopied(''), 1800);
        } catch {
            // clipboard может быть недоступен (http/старый браузер) — текст виден
            // на экране и его можно выделить руками, так что не критично.
            setCopied('');
        }
    };

    const portalTarget = typeof document !== 'undefined' ? document.body : null;
    if (!portalTarget) return null;

    return createPortal(
        <div className={cl.backdrop} onClick={onClose}>
            <div className={cl.modal} onClick={(e) => e.stopPropagation()}>
                <button type="button" className={cl.close} onClick={onClose} aria-label="Закрыть">×</button>

                <h2 className={cl.title}>Раньше входили через Google?</h2>
                <p className={cl.lead}>
                    Вход через Google больше недоступен (требование закона РФ). Но ваш
                    аккаунт никуда не делся — мы вернём к нему доступ <b>по паролю</b>{' '}
                    (после этого сможете входить по e-mail). Если у вас есть Яндекс —
                    можно войти и через него.
                </p>

                <div style={{ fontSize: 14.5, fontWeight: 700, color: '#0f172a', marginBottom: 10 }}>
                    Что нужно сделать:
                </div>
                <ol style={{ margin: '0 0 18px', paddingLeft: 20, fontSize: 14, color: '#334155', lineHeight: 1.6 }}>
                    <li style={{ marginBottom: 6 }}>
                        Отправьте письмо <b style={{ color: '#0f172a' }}>с той самой Google-почты</b>,
                        через которую вы входили (так мы убедимся, что аккаунт ваш).
                    </li>
                    <li style={{ marginBottom: 6 }}>
                        На адрес:{' '}
                        <b style={{ color: '#3b82f6' }}>{SUPPORT_EMAIL}</b>
                    </li>
                    <li>С текстом ниже (его можно скопировать кнопкой):</li>
                </ol>

                <div
                    style={{
                        background: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        borderRadius: 12,
                        padding: '12px 14px',
                        fontSize: 13.5,
                        color: '#334155',
                        lineHeight: 1.55,
                        marginBottom: 12,
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {EMAIL_BODY}
                </div>

                <div style={{ display: 'flex', gap: 10, marginBottom: 18, flexWrap: 'wrap' }}>
                    <button
                        type="button"
                        onClick={() => copy(EMAIL_BODY, 'body')}
                        style={{
                            flex: '1 1 150px',
                            padding: '11px 0',
                            borderRadius: 12,
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: 13.5,
                            fontWeight: 700,
                            fontFamily: 'inherit',
                            color: '#fff',
                            background: 'linear-gradient(135deg, #3b82f6, #a855f7)',
                        }}
                    >
                        {copied === 'body' ? 'Скопировано ✓' : 'Скопировать текст'}
                    </button>
                    <button
                        type="button"
                        onClick={() => copy(SUPPORT_EMAIL, 'email')}
                        style={{
                            flex: '1 1 150px',
                            padding: '11px 0',
                            borderRadius: 12,
                            border: '1px solid #e2e8f0',
                            cursor: 'pointer',
                            fontSize: 13.5,
                            fontWeight: 700,
                            fontFamily: 'inherit',
                            color: '#0f172a',
                            background: '#fff',
                        }}
                    >
                        {copied === 'email' ? 'Скопировано ✓' : 'Скопировать адрес'}
                    </button>
                </div>

                <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.55, margin: '0 0 20px' }}>
                    В ответ мы пришлём вам пароль. После этого входите по вашей почте и
                    полученному паролю прямо на этом экране.
                </p>

                <button
                    type="button"
                    onClick={onClose}
                    style={{
                        width: '100%',
                        padding: '12px 0',
                        borderRadius: 12,
                        border: '1px solid #e2e8f0',
                        cursor: 'pointer',
                        fontSize: 14.5,
                        fontWeight: 700,
                        fontFamily: 'inherit',
                        color: '#0f172a',
                        background: '#f8fafc',
                    }}
                >
                    Понятно
                </button>
            </div>
        </div>,
        document.body
    );
}
